import type { AvailableUnits } from '@cw-elements/profile-dropdown/utils/contants';
import type { AnalyticsInfo, SegmentTrackingHookReturn, UUID } from '@protector/utils/types';
import type { GlobalUiState } from '../../__legacy__/redux.types.ts';
import { CoreActionsTypes } from './redux.constants.ts';

export const SetSystemFlags = (flags: GlobalUiState['systemFlags']) => {
  return {
    type: CoreActionsTypes.SAVE_FLAGS,
    payload: flags
  };
};

export const SetUnitSystem = (unitSystem: AvailableUnits, segmentTracking?: SegmentTrackingHookReturn) => {
  const payload: AnalyticsInfo = {
    unitSystem
  };

  segmentTracking?.track('User Settings - Changed Unit System', payload);

  return {
    type: CoreActionsTypes.CHANGE_UNIT_SYSTEM,
    payload: unitSystem
  };
};

export const SetCurrentCompany = (company_id: UUID | null) => {
  return {
    type: CoreActionsTypes.SELECT_COMPANY,
    payload: company_id
  };
};

export const SetInterfaceLanguage = (language: string | null) => {
  return {
    type: CoreActionsTypes.CHANGE_INTERFACE_LANGUAGE,
    payload: language
  };
};

export const SetCurrentProperty = (property_id: UUID | null) => {
  return {
    type: CoreActionsTypes.SELECT_PROPERTY,
    payload: property_id
  };
};

export const SetCurrentRegion = (regionId: UUID | null) => {
  return {
    type: CoreActionsTypes.SELECT_REGION,
    payload: regionId
  };
};

export const SetCurrentArea = (areaId: UUID | null) => {
  return {
    type: CoreActionsTypes.SELECT_AREA,
    payload: areaId
  };
};

export const SetCurrentSeasons = (seasonsIds: UUID[]) => {
  return {
    type: CoreActionsTypes.SELECT_SEASONS,
    payload: seasonsIds
  };
};

export const SetDashboardState = (dashboardState: Partial<GlobalUiState['dashboardState']>) => {
  return {
    type: CoreActionsTypes.CHANGE_DASHBOARD_STATE,
    payload: dashboardState
  };
};

export const ToggleMonitoringDrawer = () => {
  return {
    type: CoreActionsTypes.TOGGLE_MONITORING_DRAWER
  };
};
